import React from 'react';
import { View, Image, StyleSheet, Dimensions } from 'react-native';
import CustomText from '../../components/customText/CustomText';
import Form from '../../components/form';
import theme from '../../constants/theme.style.js';
import NewMessageHeader from '../../components/newMessageHeader';
import FriendsSelection from '../NewMessageFriendsSelection';

const loginTurtle = require('../../assets/Turtles/main-turtle.png');

const { width } = Dimensions.get('window');

const styles = StyleSheet.create({
  messageContainer: {
    backgroundColor: theme.WHITE_COLOR,
    display: 'flex',
    flexDirection: 'row',
  },
  container: {
    width: width > 800 ? '60vw' : '100vw',
    height: `calc(100vh - ${theme.WEB_NAV_HEIGHT}px)`,
    overflow: 'hidden',
    backgroundColor: theme.GREEN_DARKER_COLOR,
    zIndex: '-1',
  },
  formContainer: {
    height: '100%',
    backgroundColor: theme.WHITE_COLOR,
    borderRadius: 30,
  },
  noMessagesContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.WHITE_COLOR,
    width: '100%',
    height: `calc(100vh - ${theme.WEB_NAV_HEIGHT}px)`,
  },
  noMessagesText: {
    marginTop: theme.CONTAINER_MARGIN,
    textAlign: 'center',
  },
  turtleTop: {
    width: '30%',
    height: 120,
  },
});

// eslint-disable-next-line react/prefer-stateless-function
export default class NewMessage extends React.Component {
  render() {
    const { navigation, friends } = this.props;
    if (friends.length > 0 && width > 800) {
      return (
        <View style={styles.messageContainer}>
          <FriendsSelection />
          <View style={styles.container}>
            <NewMessageHeader
              navigation={navigation}
              nextScreen="NewMessageTimeSelection"
              previousScreen=""
              web
              testID="newMessageHeader"
            />
            <View style={styles.formContainer}>
              <Form testID="form" />
            </View>
          </View>
        </View>
      );
    }
    if (friends.length > 0) {
      return (
        <View style={styles.container}>
          <NewMessageHeader
            navigation={navigation}
            nextScreen="NewMessageTimeSelection"
            previousScreen="NewMessageFriendsSelectionMobileWeb"
            testID="newMessageHeader"
          />
          <View style={styles.formContainer}>
            <Form testID="form" />
          </View>
        </View>
      );
    }
    return (
      <View style={styles.noMessagesContainer}>
        <Image
          style={styles.turtleTop}
          source={loginTurtle}
          resizeMode="contain"
          testID="turtleLogo"
        />
        <CustomText style={styles.noMessagesText} testID="noFriendMessage">
          No friends yet.
          {'\n'}
          Start your journey by adding friends and writing letters to them.
        </CustomText>
      </View>
    );
  }
}
